export enum IStateEnum {
  PENDING = "pending",
  IN_PROGRESS = "inProgress",
  FAILED = "failed",
  DONE = "done",
}

export type StateDto = "pe" | "ip" | "fa" | "co"

export const mapStateDtoToEnum = (StateDto: StateDto): IStateEnum => {
  switch (StateDto) {
    case "pe":
      return IStateEnum.PENDING;
    case "ip":
      return IStateEnum.IN_PROGRESS;
    case "fa":
      return IStateEnum.FAILED;
    case "co":
      return IStateEnum.DONE;
    default:
      return IStateEnum.IN_PROGRESS;
  }
}
